import rootPath, { RouteProps as BaseRouteProps } from "../routes-path";

export interface RouteProps extends BaseRouteProps {
    idtClena: string;
    hashCode: string;
}

export default rootPath + "/overeni-emailu/:hashCode";


//TODO: v nove verzi odstranit
const pathOvereniEmailuDeprecated = rootPath + "/overeni-emailu/:idtClena/:hashCode";

export {
    pathOvereniEmailuDeprecated,
}